import { render, staticRenderFns } from "./pot-1.vue?vue&type=template&id=0eb5e0e4"
import script from "./pot-1.vue?vue&type=script&lang=js"
export * from "./pot-1.vue?vue&type=script&lang=js"
import style0 from "./pot-1.vue?vue&type=style&index=0&id=0eb5e0e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports